import React from 'react';
import cn from 'classnames';

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  as?: keyof JSX.IntrinsicElements;
}

const defaultWrapperClassName = 'self-stretch flex flex-col justify-start items-start';
const defaultTextClassName = 'justify-start text-blue text-3xl font-normal font-serif leading-10';

const SectionTitle = ({ children, className, wrapperClassName = defaultWrapperClassName, as: Element = 'div' }: SectionTitleProps) => {
  return (
    <div className={cn(defaultWrapperClassName, wrapperClassName)}>
      <Element className={cn(defaultTextClassName, className)}>{children}</Element>
    </div>
  );
};

export default SectionTitle;
